module.exports = __webpack_public_path__ + "static/img/53.a59c7d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/53.png
// module id = 4khF
// module chunks = 0